import { render, staticRenderFns } from "./CursoListAddNew.vue?vue&type=template&id=7cb622e9&"
import script from "./CursoListAddNew.vue?vue&type=script&lang=js&"
export * from "./CursoListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CursoListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports